// // import React from 'react';
// // import { 
// //   TrendingUp, 
// //   AlertCircle, 
// //   Calendar, 
// //   Ship, 
// //   CheckCircle,
// //   Clock,
// //   DollarSign,
// //   Users
// // } from 'lucide-react';
// // import StatsCards from '../StatsCards/StatsCards';
// // import ShipMaintenanceTable from '../ShipMaintenanceTable/ShipMaintenanceTable';
// // import MaintenanceChart from '../Charts/MaintenanceChart';

// // const Dashboard = () => {
// //   const stats = [
// //     {
// //       title: 'Total Vessels',
// //       value: '156',
// //       change: '+12%',
// //       icon: <Ship className="text-blue-600" size={24} />,
// //       color: 'bg-blue-50 dark:bg-blue-900/20',
// //     },
// //     {
// //       title: 'Pending Maintenance',
// //       value: '24',
// //       change: '+3%',
// //       icon: <AlertCircle className="text-amber-600" size={24} />,
// //       color: 'bg-amber-50 dark:bg-amber-900/20',
// //     },
// //     {
// //       title: 'Completed This Month',
// //       value: '42',
// //       change: '+18%',
// //       icon: <CheckCircle className="text-emerald-600" size={24} />,
// //       color: 'bg-emerald-50 dark:bg-emerald-900/20',
// //     },
// //     {
// //       title: 'Avg. Cost Per Ship',
// //       value: '$45,230',
// //       change: '-2%',
// //       icon: <DollarSign className="text-purple-600" size={24} />,
// //       color: 'bg-purple-50 dark:bg-purple-900/20',
// //     },
// //   ];

// //   const upcomingMaintenance = [
// //     { vessel: 'MV Ocean King', date: '2024-03-15', type: 'Dry Dock', status: 'High' },
// //     { vessel: 'MV Sea Pearl', date: '2024-03-18', type: 'Routine', status: 'Medium' },
// //     { vessel: 'MV Blue Wave', date: '2024-03-22', type: 'Engine', status: 'High' },
// //     { vessel: 'MV Star Voyager', date: '2024-03-25', type: 'Hull', status: 'Low' },
// //   ];

// //   const recentActivities = [
// //     { activity: 'MV Ocean King maintenance completed', time: '2 hours ago' },
// //     { activity: 'New vessel added: MV Sea Explorer', time: '4 hours ago' },
// //     { activity: 'Maintenance schedule updated', time: '1 day ago' },
// //     { activity: 'System backup completed', time: '2 days ago' },
// //   ];

// //   return (
// //     <div className="space-y-6">
// //       <div>
// //         <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Dashboard Overview</h1>
// //         <p className="text-gray-600 dark:text-gray-400">Welcome back! Here's what's happening with your fleet.</p>
// //       </div>

// //       <StatsCards stats={stats} />

// //       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
// //         <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
// //           <div className="flex items-center justify-between mb-6">
// //             <div>
// //               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
// //                 Maintenance Overview
// //               </h3>
// //               <p className="text-sm text-gray-600 dark:text-gray-400">Monthly maintenance trends</p>
// //             </div>
// //             <Calendar className="text-gray-400" size={20} />
// //           </div>
// //           <MaintenanceChart />
// //         </div>

// //         <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
// //           <div className="flex items-center justify-between mb-6">
// //             <div>
// //               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
// //                 Upcoming Maintenance
// //               </h3>
// //               <p className="text-sm text-gray-600 dark:text-gray-400">Next 7 days schedule</p>
// //             </div>
// //             <Clock className="text-gray-400" size={20} />
// //           </div>
// //           <div className="space-y-4">
// //             {upcomingMaintenance.map((item, index) => (
// //               <div key={index} className="flex items-center justify-between p-3 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg">
// //                 <div>
// //                   <p className="font-medium text-gray-900 dark:text-white">{item.vessel}</p>
// //                   <p className="text-sm text-gray-600 dark:text-gray-400">{item.type}</p>
// //                 </div>
// //                 <div className="text-right">
// //                   <p className="font-medium text-gray-900 dark:text-white">{item.date}</p>
// //                   <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
// //                     item.status === 'High' 
// //                       ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
// //                       : item.status === 'Medium'
// //                       ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
// //                       : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300'
// //                   }`}>
// //                     {item.status} Priority
// //                   </span>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
// //         <div className="lg:col-span-2">
// //           <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
// //             <div className="p-6 border-b border-gray-200 dark:border-gray-700">
// //               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
// //                 Maintenance Predictions
// //               </h3>
// //             </div>
// //             <ShipMaintenanceTable />
// //           </div>
// //         </div>

// //         <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
// //           <div className="flex items-center justify-between mb-6">
// //             <div>
// //               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
// //                 Recent Activity
// //               </h3>
// //               <p className="text-sm text-gray-600 dark:text-gray-400">Latest system updates</p>
// //             </div>
// //             <Users className="text-gray-400" size={20} />
// //           </div>
// //           <div className="space-y-4">
// //             {recentActivities.map((activity, index) => (
// //               <div key={index} className="flex items-start space-x-3">
// //                 <div className="w-2 h-2 mt-2 rounded-full bg-blue-500"></div>
// //                 <div>
// //                   <p className="text-sm text-gray-900 dark:text-white">{activity.activity}</p>
// //                   <p className="text-xs text-gray-500 dark:text-gray-400">{activity.time}</p>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //           <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
// //             <div className="flex items-center justify-between">
// //               <div>
// //                 <p className="text-sm font-medium text-gray-900 dark:text-white">System Health</p>
// //                 <p className="text-xs text-gray-600 dark:text-gray-400">All systems operational</p>
// //               </div>
// //               <div className="w-12 h-12 rounded-full bg-gradient-to-r from-emerald-500 to-emerald-400 flex items-center justify-center">
// //                 <CheckCircle className="text-white" size={24} />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Dashboard;

// import React, { useState } from 'react';
// import { 
//   TrendingUp, 
//   TrendingDown,
//   AlertCircle, 
//   Calendar, 
//   Ship, 
//   CheckCircle,
//   Clock,
//   DollarSign,
//   Users,
//   Filter,
//   Download,
//   ChevronUp,
//   ChevronDown,
//   MoreVertical,
//   Eye,
//   Edit,
//   Trash2,
//   ExternalLink
// } from 'lucide-react';
// import StatsCards from '../StatsCards/StatsCards';
// import ShipMaintenanceTable from '../ShipMaintenanceTable/ShipMaintenanceTable';
// import MaintenanceChart from '../Charts/MaintenanceChart';

// const Dashboard = () => {
//   const [activeFilter, setActiveFilter] = useState('all');
//   const [timeRange, setTimeRange] = useState('month');

//   const stats = [
//     {
//       title: 'Total Vessels',
//       value: '156',
//       change: '+12%',
//       trend: 'up',
//       icon: <Ship className="text-blue-600" size={24} />,
//       color: 'from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-900/10',
//     },
//     {
//       title: 'Pending Maintenance',
//       value: '24',
//       change: '+3%',
//       trend: 'up',
//       icon: <AlertCircle className="text-amber-600" size={24} />,
//       color: 'from-amber-50 to-amber-100 dark:from-amber-900/20 dark:to-amber-900/10',
//     },
//     {
//       title: 'Completed This Month',
//       value: '42',
//       change: '+18%',
//       trend: 'up',
//       icon: <CheckCircle className="text-emerald-600" size={24} />,
//       color: 'from-emerald-50 to-emerald-100 dark:from-emerald-900/20 dark:to-emerald-900/10',
//     },
//     {
//       title: 'Avg. Cost Per Ship',
//       value: '$45,230',
//       change: '-2%',
//       trend: 'down',
//       icon: <DollarSign className="text-purple-600" size={24} />,
//       color: 'from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-900/10',
//     },
//   ];

//   const upcomingMaintenance = [
//     { 
//       vessel: 'MV Ocean King', 
//       date: '2024-03-15', 
//       type: 'Dry Dock', 
//       status: 'High',
//       daysLeft: 3,
//       imo: 'IMO9876543'
//     },
//     { 
//       vessel: 'MV Sea Pearl', 
//       date: '2024-03-18', 
//       type: 'Routine', 
//       status: 'Medium',
//       daysLeft: 6,
//       imo: 'IMO8765432'
//     },
//     { 
//       vessel: 'MV Blue Wave', 
//       date: '2024-03-22', 
//       type: 'Engine', 
//       status: 'High',
//       daysLeft: 10,
//       imo: 'IMO7654321'
//     },
//     { 
//       vessel: 'MV Star Voyager', 
//       date: '2024-03-25', 
//       type: 'Hull', 
//       status: 'Low',
//       daysLeft: 13,
//       imo: 'IMO6543210'
//     },
//   ];

//   const recentActivities = [
//     { activity: 'MV Ocean King maintenance completed', time: '2 hours ago', user: 'John Smith' },
//     { activity: 'New vessel added: MV Sea Explorer', time: '4 hours ago', user: 'Sarah Johnson' },
//     { activity: 'Maintenance schedule updated', time: '1 day ago', user: 'Mike Wilson' },
//     { activity: 'System backup completed', time: '2 days ago', user: 'System Admin' },
//   ];

//   const filters = [
//     { id: 'all', label: 'All' },
//     { id: 'upcoming', label: 'Upcoming' },
//     { id: 'in-progress', label: 'In Progress' },
//     { id: 'completed', label: 'Completed' },
//     { id: 'delayed', label: 'Delayed' },
//   ];

//   const timeRanges = [
//     { id: 'week', label: 'Week' },
//     { id: 'month', label: 'Month' },
//     { id: 'quarter', label: 'Quarter' },
//     { id: 'year', label: 'Year' },
//   ];

//   return (
//     <div className="space-y-6">
//       {/* Header with Filters */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//         <div>
//           <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white">
//             Dashboard Overview
//           </h1>
//           <p className="text-gray-600 dark:text-gray-400 mt-1">
//             Welcome back! Here's what's happening with your fleet.
//           </p>
//         </div>
        
//         <div className="flex flex-wrap gap-2">
//           <div className="flex items-center space-x-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 px-3 py-2">
//             <Filter size={18} className="text-gray-400" />
//             <select 
//               value={activeFilter}
//               onChange={(e) => setActiveFilter(e.target.value)}
//               className="bg-transparent border-none focus:outline-none text-sm text-gray-700 dark:text-gray-300"
//             >
//               {filters.map(filter => (
//                 <option key={filter.id} value={filter.id}>{filter.label}</option>
//               ))}
//             </select>
//           </div>
          
//           <div className="flex items-center space-x-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 px-3 py-2">
//             <Calendar size={18} className="text-gray-400" />
//             <select 
//               value={timeRange}
//               onChange={(e) => setTimeRange(e.target.value)}
//               className="bg-transparent border-none focus:outline-none text-sm text-gray-700 dark:text-gray-300"
//             >
//               {timeRanges.map(range => (
//                 <option key={range.id} value={range.id}>{range.label}</option>
//               ))}
//             </select>
//           </div>
          
//           <button className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2 transition-colors">
//             <Download size={18} />
//             <span className="hidden sm:inline">Export</span>
//           </button>
//         </div>
//       </div>

//       {/* Stats Cards */}
//       <StatsCards stats={stats} />

//       {/* Charts Section */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//         {/* Maintenance Chart */}
//         <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
//           <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
//             <div>
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 Maintenance Overview
//               </h3>
//               <p className="text-sm text-gray-600 dark:text-gray-400">Monthly maintenance trends</p>
//             </div>
//             <div className="flex items-center space-x-2">
//               <span className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
//                 Scheduled
//               </span>
//               <span className="text-xs px-2 py-1 rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300">
//                 Completed
//               </span>
//               <span className="text-xs px-2 py-1 rounded-full bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300">
//                 Pending
//               </span>
//             </div>
//           </div>
//           <MaintenanceChart />
//         </div>

//         {/* Upcoming Maintenance */}
//         <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
//           <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
//             <div>
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 Upcoming Maintenance
//               </h3>
//               <p className="text-sm text-gray-600 dark:text-gray-400">Next 14 days schedule</p>
//             </div>
//             <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center space-x-1">
//               <span>View All</span>
//               <ExternalLink size={16} />
//             </button>
//           </div>
          
//           <div className="space-y-4">
//             {upcomingMaintenance.map((item, index) => (
//               <div key={index} className="p-4 rounded-lg border border-gray-200 dark:border-gray-800 hover:border-blue-300 dark:hover:border-blue-700 transition-colors">
//                 <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//                   <div className="flex-1">
//                     <div className="flex items-center space-x-3">
//                       <div className="w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center">
//                         <Ship size={18} className="text-blue-600 dark:text-blue-400" />
//                       </div>
//                       <div>
//                         <p className="font-medium text-gray-900 dark:text-white">{item.vessel}</p>
//                         <p className="text-sm text-gray-600 dark:text-gray-400">{item.imo} • {item.type}</p>
//                       </div>
//                     </div>
//                   </div>
                  
//                   <div className="flex flex-col sm:items-end gap-2">
//                     <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
//                       item.status === 'High' 
//                         ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
//                         : item.status === 'Medium'
//                         ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
//                         : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300'
//                     }`}>
//                       {item.status} Priority
//                     </span>
//                     <div className="text-right">
//                       <p className="font-medium text-gray-900 dark:text-white">{item.date}</p>
//                       <p className="text-sm text-gray-600 dark:text-gray-400">{item.daysLeft} days left</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Main Table Section */}
//       <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden">
//         <div className="p-6 border-b border-gray-200 dark:border-gray-800">
//           <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
//             <div>
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 Maintenance Predictions
//               </h3>
//               <p className="text-sm text-gray-600 dark:text-gray-400">
//                 View and manage all scheduled maintenance activities
//               </p>
//             </div>
//             <div className="flex items-center space-x-2">
//               <button className="flex items-center space-x-2 px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800">
//                 <Filter size={18} />
//                 <span>Filter</span>
//               </button>
//               <button className="flex items-center space-x-2 px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800">
//                 <Download size={18} />
//                 <span>Export CSV</span>
//               </button>
//             </div>
//           </div>
//         </div>
        
//         <div className="overflow-x-auto">
//           <ShipMaintenanceTable />
//         </div>
//       </div>

//       {/* Recent Activity & Quick Stats */}
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         <div className="lg:col-span-2">
//           <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
//             <div className="flex items-center justify-between mb-6">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                   Recent Activity
//                 </h3>
//                 <p className="text-sm text-gray-600 dark:text-gray-400">Latest system updates</p>
//               </div>
//               <Users className="text-gray-400" size={20} />
//             </div>
            
//             <div className="space-y-4">
//               {recentActivities.map((activity, index) => (
//                 <div key={index} className="flex items-start space-x-3 p-3 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg">
//                   <div className="w-2 h-2 mt-2 rounded-full bg-blue-500"></div>
//                   <div className="flex-1">
//                     <p className="text-sm text-gray-900 dark:text-white">{activity.activity}</p>
//                     <div className="flex items-center justify-between mt-1">
//                       <p className="text-xs text-gray-500 dark:text-gray-400">by {activity.user}</p>
//                       <p className="text-xs text-gray-500 dark:text-gray-400">{activity.time}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
//           <div className="flex items-center justify-between mb-6">
//             <div>
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 System Health
//               </h3>
//               <p className="text-sm text-gray-600 dark:text-gray-400">Real-time monitoring</p>
//             </div>
//             <div className="w-12 h-12 rounded-full bg-gradient-to-r from-emerald-500 to-emerald-400 flex items-center justify-center">
//               <CheckCircle className="text-white" size={24} />
//             </div>
//           </div>
          
//           <div className="space-y-4">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center space-x-3">
//                 <div className="w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
//                   <CheckCircle className="text-blue-600 dark:text-blue-400" size={16} />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-900 dark:text-white">API Status</p>
//                   <p className="text-xs text-gray-500 dark:text-gray-400">Predictive models</p>
//                 </div>
//               </div>
//               <span className="px-2 py-1 text-xs rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300">
//                 Operational
//               </span>
//             </div>
            
//             <div className="flex items-center justify-between">
//               <div className="flex items-center space-x-3">
//                 <div className="w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
//                   <CheckCircle className="text-blue-600 dark:text-blue-400" size={16} />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-900 dark:text-white">Database</p>
//                   <p className="text-xs text-gray-500 dark:text-gray-400">Maintenance records</p>
//                 </div>
//               </div>
//               <span className="px-2 py-1 text-xs rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300">
//                 Online
//               </span>
//             </div>
            
//             <div className="flex items-center justify-between">
//               <div className="flex items-center space-x-3">
//                 <div className="w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
//                   <CheckCircle className="text-blue-600 dark:text-blue-400" size={16} />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-900 dark:text-white">Storage</p>
//                   <p className="text-xs text-gray-500 dark:text-gray-400">Reports & files</p>
//                 </div>
//               </div>
//               <span className="px-2 py-1 text-xs rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300">
//                 82% Used
//               </span>
//             </div>
//           </div>
          
//           <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-800">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm font-medium text-gray-900 dark:text-white">Uptime</p>
//                 <p className="text-xs text-gray-500 dark:text-gray-400">Last 30 days</p>
//               </div>
//               <div className="text-right">
//                 <p className="text-lg font-bold text-gray-900 dark:text-white">99.9%</p>
//                 <p className="text-xs text-emerald-600 dark:text-emerald-400">+0.2%</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

import React, { useState } from 'react';
import { 
  TrendingUp, 
  TrendingDown,
  AlertCircle, 
  Calendar, 
  Ship, 
  CheckCircle,
  Clock,
  DollarSign,
  Users,
  Filter,
  Download,
  ChevronUp,
  ChevronDown,
  MoreVertical,
  Eye,
  Edit,
  Trash2,
  ExternalLink
} from 'lucide-react';
import StatsCards from '../StatsCards/StatsCards';
import ShipMaintenanceTable from '../ShipMaintenanceTable/ShipMaintenanceTable';
import MaintenanceChart from '../Charts/MaintenanceChart';

const Dashboard = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [timeRange, setTimeRange] = useState('month');

  const stats = [
    {
      title: 'Total Vessels',
      value: '156',
      change: '+12%',
      trend: 'up',
      icon: <Ship className="text-blue-600" size={24} />,
      color: 'from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-900/10',
    },
    {
      title: 'Pending Maintenance',
      value: '24',
      change: '+3%',
      trend: 'up',
      icon: <AlertCircle className="text-amber-600" size={24} />,
      color: 'from-amber-50 to-amber-100 dark:from-amber-900/20 dark:to-amber-900/10',
    },
    {
      title: 'Completed This Month',
      value: '42',
      change: '+18%',
      trend: 'up',
      icon: <CheckCircle className="text-emerald-600" size={24} />,
      color: 'from-emerald-50 to-emerald-100 dark:from-emerald-900/20 dark:to-emerald-900/10',
    },
    {
      title: 'Avg. Cost Per Ship',
      value: '$45,230',
      change: '-2%',
      trend: 'down',
      icon: <DollarSign className="text-purple-600" size={24} />,
      color: 'from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-900/10',
    },
  ];

  // Generate upcoming maintenance dates (this year and next year)
  const generateUpcomingDates = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    
    return [
      {
        vessel: 'MV Ocean King', 
        date: new Date(currentYear, currentMonth, Math.min(now.getDate() + 3, 28)), 
        type: 'Dry Dock', 
        status: 'High',
        daysLeft: 3,
        imo: 'IMO9876543'
      },
      {
        vessel: 'MV Sea Pearl', 
        date: new Date(currentYear, currentMonth, Math.min(now.getDate() + 6, 28)),
        type: 'Routine', 
        status: 'Medium',
        daysLeft: 6,
        imo: 'IMO8765432'
      },
      {
        vessel: 'MV Blue Wave', 
        date: new Date(currentYear, currentMonth + 1, 5), // Next month
        type: 'Engine', 
        status: 'High',
        daysLeft: 35,
        imo: 'IMO7654321'
      },
      {
        vessel: 'MV Star Voyager', 
        date: new Date(currentYear, currentMonth + 2, 15), // Two months ahead
        type: 'Hull', 
        status: 'Low',
        daysLeft: 75,
        imo: 'IMO6543210'
      },
      {
        vessel: 'MV Atlantic Queen', 
        date: new Date(currentYear + 1, 0, 10), // Next year January
        type: 'Dry Dock', 
        status: 'Medium',
        daysLeft: 285,
        imo: 'IMO5432109'
      },
      {
        vessel: 'MV Pacific Rider', 
        date: new Date(currentYear + 1, 3, 20), // Next year April
        type: 'Routine', 
        status: 'Low',
        daysLeft: 385,
        imo: 'IMO4321098'
      }
    ];
  };

  // Sort upcoming maintenance by date (nearest first)
  const upcomingMaintenance = generateUpcomingDates().sort((a, b) => 
    new Date(a.date) - new Date(b.date)
  );

  const recentActivities = [
    { activity: 'MV Ocean King maintenance completed', time: '2 hours ago', user: 'John Smith' },
    { activity: 'New vessel added: MV Sea Explorer', time: '4 hours ago', user: 'Sarah Johnson' },
    { activity: 'Maintenance schedule updated', time: '1 day ago', user: 'Mike Wilson' },
    { activity: 'System backup completed', time: '2 days ago', user: 'System Admin' },
  ];

  const filters = [
    { id: 'all', label: 'All' },
    { id: 'upcoming', label: 'Upcoming' },
    { id: 'in-progress', label: 'In Progress' },
    { id: 'completed', label: 'Completed' },
    { id: 'delayed', label: 'Delayed' },
  ];

  const timeRanges = [
    { id: 'week', label: 'Week' },
    { id: 'month', label: 'Month' },
    { id: 'quarter', label: 'Quarter' },
    { id: 'year', label: 'Year' },
  ];

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getDaysLeft = (date) => {
    const now = new Date();
    const diffTime = date - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  return (
    <div className="space-y-6">
      {/* Header with Filters */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white">
            Dashboard Overview
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Welcome back! Here's what's happening with your fleet.
          </p>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <div className="flex items-center space-x-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 px-3 py-2">
            <Filter size={18} className="text-gray-400" />
            <select 
              value={activeFilter}
              onChange={(e) => setActiveFilter(e.target.value)}
              className="bg-transparent border-none focus:outline-none text-sm text-gray-700 dark:text-gray-300"
            >
              {filters.map(filter => (
                <option key={filter.id} value={filter.id}>{filter.label}</option>
              ))}
            </select>
          </div>
          
          <div className="flex items-center space-x-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 px-3 py-2">
            <Calendar size={18} className="text-gray-400" />
            <select 
              value={timeRange}
              onChange={(e) => setTimeRange(e.target.value)}
              className="bg-transparent border-none focus:outline-none text-sm text-gray-700 dark:text-gray-300"
            >
              {timeRanges.map(range => (
                <option key={range.id} value={range.id}>{range.label}</option>
              ))}
            </select>
          </div>
          
          <button className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2 transition-colors">
            <Download size={18} />
            <span className="hidden sm:inline">Export</span>
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <StatsCards stats={stats} />

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Maintenance Chart */}
        <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Maintenance Overview
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">Monthly maintenance trends</p>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
                Scheduled
              </span>
              <span className="text-xs px-2 py-1 rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300">
                Completed
              </span>
              <span className="text-xs px-2 py-1 rounded-full bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300">
                Pending
              </span>
            </div>
          </div>
          <MaintenanceChart />
        </div>

        {/* Upcoming Maintenance */}
        <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Upcoming Maintenance
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                This year & next year schedule (Sorted by nearest dates)
              </p>
            </div>
            <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center space-x-1">
              <span>View All</span>
              <ExternalLink size={16} />
            </button>
          </div>
          
          <div className="space-y-4 max-h-80 overflow-y-auto pr-2">
            {upcomingMaintenance.map((item, index) => {
              const daysLeft = getDaysLeft(item.date);
              return (
                <div key={index} className="p-4 rounded-lg border border-gray-200 dark:border-gray-800 hover:border-blue-300 dark:hover:border-blue-700 transition-colors">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center">
                          <Ship size={18} className="text-blue-600 dark:text-blue-400" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-900 dark:text-white">{item.vessel}</p>
                          <p className="text-sm text-gray-600 dark:text-gray-400">{item.imo} • {item.type}</p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex flex-col sm:items-end gap-2">
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                        item.status === 'High' 
                          ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
                          : item.status === 'Medium'
                          ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
                          : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300'
                      }`}>
                        {item.status} Priority
                      </span>
                      <div className="text-right">
                        <p className="font-medium text-gray-900 dark:text-white">{formatDate(item.date)}</p>
                        <p className={`text-sm ${daysLeft <= 7 ? 'text-red-600 dark:text-red-400' : 'text-gray-600 dark:text-gray-400'}`}>
                          {daysLeft <= 0 ? 'Overdue' : `${daysLeft} days left`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Main Table Section */}
      <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden">
        <div className="p-6 border-b border-gray-200 dark:border-gray-800">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Maintenance Predictions
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Showing nearest maintenance dates first (sorted by date)
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <button className="flex items-center space-x-2 px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800">
                <Filter size={18} />
                <span>Filter</span>
              </button>
              <button className="flex items-center space-x-2 px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800">
                <Download size={18} />
                <span>Export CSV</span>
              </button>
            </div>
          </div>
        </div>
        
        <div className="overflow-hidden">
          {/* Add fixed height and scroll to table */}
          <div className="max-h-96 overflow-y-auto">
            <ShipMaintenanceTable />
          </div>
        </div>
      </div>

      {/* Recent Activity & Quick Stats */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Recent Activity
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">Latest system updates</p>
              </div>
              <Users className="text-gray-400" size={20} />
            </div>
            
            <div className="space-y-4 max-h-64 overflow-y-auto pr-2">
              {recentActivities.map((activity, index) => (
                <div key={index} className="flex items-start space-x-3 p-3 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg">
                  <div className="w-2 h-2 mt-2 rounded-full bg-blue-500"></div>
                  <div className="flex-1">
                    <p className="text-sm text-gray-900 dark:text-white">{activity.activity}</p>
                    <div className="flex items-center justify-between mt-1">
                      <p className="text-xs text-gray-500 dark:text-gray-400">by {activity.user}</p>
                      <p className="text-xs text-gray-500 dark:text-gray-400">{activity.time}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                System Health
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">Real-time monitoring</p>
            </div>
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-emerald-500 to-emerald-400 flex items-center justify-center">
              <CheckCircle className="text-white" size={24} />
            </div>
          </div>
          
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                  <CheckCircle className="text-blue-600 dark:text-blue-400" size={16} />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-white">API Status</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">Predictive models</p>
                </div>
              </div>
              <span className="px-2 py-1 text-xs rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300">
                Operational
              </span>
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                  <CheckCircle className="text-blue-600 dark:text-blue-400" size={16} />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-white">Database</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">Maintenance records</p>
                </div>
              </div>
              <span className="px-2 py-1 text-xs rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300">
                Online
              </span>
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                  <CheckCircle className="text-blue-600 dark:text-blue-400" size={16} />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-white">Storage</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">Reports & files</p>
                </div>
              </div>
              <span className="px-2 py-1 text-xs rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300">
                82% Used
              </span>
            </div>
          </div>
          
          <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-800">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">Uptime</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">Last 30 days</p>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold text-gray-900 dark:text-white">99.9%</p>
                <p className="text-xs text-emerald-600 dark:text-emerald-400">+0.2%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;